module.exports = __webpack_public_path__ + "img/footer_search_on.c3976cfd.png";